import ValidationRule from '../validation.rule.js';
import PasswordItemRule from './password-item.rule';

export default class ExpectUppercaseRule extends PasswordItemRule {
    // https://theprogrammingexpert.com/check-if-string-contains-uppercase-javascript/
    checkUppercase(str){
        for (var i=0; i<str.length; i++){
            if (str.charAt(i) == str.charAt(i).toUpperCase() && str.charAt(i).match(/[A-Z]/i)){
                return true;
            }
        }
        return false;
    }

    isValid() {
        return this.checkUppercase(this.password.element.value);
    }

    getRuleName() {
        return 'expect-uppercase';
    }
}
